const RoundedCheck = (props: any) => (
    <svg width={16} height={16} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M8 1.333A6.67 6.67 0 0 0 1.333 8 6.67 6.67 0 0 0 8 14.667 6.67 6.67 0 0 0 14.667 8 6.67 6.67 0 0 0 8 1.333ZM6.193 10.86 3.8 8.467a.664.664 0 1 1 .94-.94l1.927 1.92 4.586-4.587a.664.664 0 1 1 .94.94l-5.06 5.06a.664.664 0 0 1-.94 0Z"
            fill="#827485"
        />
    </svg>
)

export default RoundedCheck
